module.exports = __webpack_public_path__ + "assets/img/9_55_big.bc7a246e.jpg";